// src/components/MealCard.js
import React, { useState } from 'react';
import { Card, Badge, Button, Col, Row } from 'react-bootstrap';
import moment from 'moment';
import DEJEUNER from "../../../../assets/images/diet/dejeuner1.png";

const MealCard = ({ meal, isPast }) => {
    // State is LOCAL to this component
    const [media, setMedia] = useState({
        type: null,
        src: '',
        title: ''
    });

    const closeMedia = () => {
        setMedia({ type: null, src: '', title: '' });
    };

    // Nouvelle logique de "toggle" pour les boutons
    const toggleMedia = (type, src, title) => {
        // Si le média affiché est déjà du même type, le fermer.
        if (media.type === type) {
            closeMedia();
        } else {
            // Sinon, afficher le nouveau média.
            setMedia({ type, src, title });
        }
    };

    const recipe = meal?.recipe || {};
    const totalNV = recipe?.totalNV || {};
    const ingredients = recipe?.ingredients || [];

    return (
        <div className="mb-4">
            <Row className="g-3">
                <Col md={media.type ? 6 : 12}>
                    <Card className={`meal-card ${meal?.consumed ? 'border-success' : 'border-light'}`}>
                        <Card.Body className="p-3">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <div className="flex-grow-1">
                                    <h6 className="mb-1 fw-bold">
                                        {recipe.recipeName || 'Recette sans nom'}
                                    </h6>
                                    {recipe.category && (<Badge bg="light" text="dark" className="me-2 mb-2">{recipe.category}</Badge>)}
                                    {meal?.consumed && (<Badge bg="success" className="me-2 mb-2">Consommé</Badge>)}
                                    {!meal?.consumed && isPast && (<Badge bg="warning" text="dark" className="me-2 mb-2">Non consommé</Badge>)}
                                </div>
                            </div>

                            {/* ... Votre contenu de carte existant ... */}
                            {recipe.description && (<p className="text-muted small mb-2">{recipe.description}</p>)}
                            <div className="nutrition-info mb-3">
                                <div className="d-flex flex-wrap gap-2 mb-2">
                                    <Badge bg="primary">{totalNV.calories || 0} kcal</Badge>
                                    <Badge bg="info" text="dark">P: {totalNV.protein || 0}g</Badge>
                                    <Badge bg="warning" text="dark">L: {totalNV.fats || 0}g</Badge>
                                    <Badge bg="success">G: {totalNV.carbs || 0}g</Badge>
                                </div>
                            </div>
                             {/* Ingrédients */}
                            {ingredients.length > 0 && (
                                <details>
                                <summary className="fw-semibold mb-2" style={{ cursor: 'pointer' }}>
                                    Ingrédients ({ingredients.length})
                                </summary>
                                <div>
                                    {ingredients.map((ing, i) => (
                                    <div key={i} className="d-flex justify-content-between align-items-center py-1 border-bottom border-light">
                                        <span>{ing.ingredientName}</span>
                                        <Badge bg="outline-secondary" text="dark">
                                        {ing.quantity} {ing.unit}
                                        </Badge>
                                    </div>
                                    ))}
                                </div>
                                </details>
                            )}

                            {/* Instructions */}
                            {recipe.instructions && (
                                <details className="mt-2">
                                <summary className="fw-semibold mb-2" style={{ cursor: 'pointer' }}>
                                    Instructions
                                </summary>
                                <div className="bg-light p-2 rounded small">
                                    {recipe.instructions.split('\n').map((line, i) =>
                                    line.trim() && <p key={i} className="mb-1">{line}</p>
                                    )}
                                </div>
                                </details>
                            )}

                            {(recipe?.imageUrl || recipe?.videoUrl) && (
                                <div className="media-links mt-3">
                                    <div className="d-flex gap-2">
                                        {recipe?.imageUrl && (
                                            <Button
                                                size="sm"
                                                variant={media.type === 'image' ? 'primary' : 'outline-primary'}
                                                onClick={() => toggleMedia('image', recipe.imageUrl || DEJEUNER, recipe.recipeName || 'Image de la recette')}
                                            >
                                                Image
                                            </Button>
                                        )}
                                        {recipe.videoUrl && (
                                            <Button
                                                size="sm"
                                                variant={media.type === 'video' ? 'danger' : 'outline-danger'}
                                                onClick={() => toggleMedia('video', recipe.videoUrl, recipe.recipeName || 'Vidéo de la recette')}
                                            >
                                                Vidéo
                                            </Button>
                                        )}
                                    </div>
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>

                {media.type && (
                    <Col md={6}>
                        <div className="media-display border rounded p-3">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <h5 className="mb-0">{media.title}</h5>
                               
                            </div>
                            {media.type === 'image' && (
                                <img src={DEJEUNER} alt={media.title} className="w-100 rounded" style={{ height: '27vh' }} />
                            )}
                            {media.type === 'video' && (
                                <video src={media.src} controls className="w-100 rounded" style={{ minHeight: '240px', maxHeight: '1000px' }} >Votre navigateur ne supporte pas la lecture de vidéos.</video>
                            )}
                        </div>
                    </Col>
                )}
            </Row>
        </div>
    );
};

export default MealCard;